/**
 * tasks domain (legacy) — /tasks/* (2 routes, retiring at v3.0 cutover).
 * v3 equivalent lives in domains/tasks.ts.
 */

import type { RequestOptions, TaskCategory } from '@retail-ops/shared-types';
import type { ApiHttpClient } from '../http.js';

export interface LegacyAutoTaskRequest {
  Category: TaskCategory | string;
  Title: string;
  Description: string;
  AssignedTo: string;
  Priority: 'Low' | 'Normal' | 'High' | 'Critical';
  DueDate?: string;
  RelatedCifId?: string;
  RelatedCartId?: string;
  NotifyTeams?: boolean;
  NotifyEmail?: boolean;
}

export interface LegacyAutoTaskResult {
  Success: boolean;
  TaskId?: string;
  Error?: string;
}

export interface LegacyRunScanResult {
  Success: boolean;
  TasksCreated?: number;
  TasksEscalated?: number;
  TasksRemoved?: number;
  ElapsedMs?: number;
}

export class LegacyTasksApi {
  public constructor(private readonly http: ApiHttpClient) {}

  public createAutomated(
    req: LegacyAutoTaskRequest,
    opts?: RequestOptions
  ): Promise<LegacyAutoTaskResult> {
    return this.http.post<LegacyAutoTaskResult>('/tasks/create-automated', { ...opts, body: req });
  }

  public runScan(opts?: RequestOptions): Promise<LegacyRunScanResult> {
    return this.http.post<LegacyRunScanResult>('/tasks/run-scan', { ...opts, body: {} });
  }
}
